<template>
    <div class="service-package-price">
        <div
            v-if="showStrikethrough && originalPrice"
            class="service-package-price-strikethrough">
            <span>
                {{ getMoneyObjectAsString(originalPrice) }}
            </span>
            <span>{{ getMoneyObjectAsString(price) }}</span>
        </div>
        <div v-else>
            <span>{{ getMoneyObjectAsString(price) }}</span>
        </div>
        <div class="service-package-price-text">
            {{
                t({
                    key: 'service_package.per_booking',
                    format: LabelFormat.Capitalize,
                })
            }}
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import { Money } from '@libs/money/money.interfaces';
    import { t } from '@shared/helpers/translation';
    import { LabelFormat } from '@shared/interfaces/translation';

    export default defineComponent({
        name: 'ServicePackagePrice',
        methods: { t, getMoneyObjectAsString },
        props: {
            price: {
                type: Object as PropType<Money>,
                required: true,
            },
            originalPrice: {
                type: Object as PropType<Money | null>,
                default: null,
            },
            showStrikethrough: {
                type: Boolean,
                default: false,
            },
        },
        setup() {
            return {
                LabelFormat,
            };
        },
    });
</script>

<style scoped lang="scss">
    @forward '../ServicePackage.scss';
</style>
